import { chatGPT, mj, openai } from '@/config/model';

export default {
	name: 'Refund',

	data() {
		return {
			chatGPT,
			openai
		};
	}
};